export default __webpack_public_path__ + "static/media/homepage-image.46286a5d.svg";